import * as types from '../actions';
const initialState = {
    items: [],
    status:0,
    item:{
        id:'',
        name:'',
    },
    activity:'',
    count:0,
    errorData:''    
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {

        case types.CANCEL_REASONS_LIST_SUCCESS:
        case types.CANCEL_REASONS_MASTER_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data.results ? response.data.results : response.data,
                    status: response.status,
                    activity:types.CANCEL_REASONS_LIST_SUCCESS,
                    count:response.data.count
                };
            }else{
                return {
                    ...state,
                    status: response.status,     
                    activity:types.CANCEL_REASONS_LIST_ERROR,                            
                };
            }       

        case types.CANCEL_REASONS_ADD_SUCCESS:
        case types.CANCEL_REASONS_MASTER_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.CANCEL_REASONS_ADD_SUCCESS,
                }   
            }else{
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity:types.CANCEL_REASONS_ADD_ERROR,
                }   
            }

        case types.CANCEL_REASONS_LOAD_SUCCESS: 
        case types.CANCEL_REASONS_MASTER_LOAD_SUCCESS:     
            if(response.status===200){     
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        name: response.data.name
                    },
                    status: response.status,
                    activity:types.CANCEL_REASONS_LOAD_SUCCESS,               
                }     
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.CANCEL_REASONS_LOAD_ERROR,         
                }   
            }  
       
            case types.CANCEL_REASONS_MODIFY_SUCCESS:
            case types.CANCEL_REASONS_MASTER_MODIFY_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.CANCEL_REASONS_MODIFY_SUCCESS,         
                }    
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.CANCEL_REASONS_MODIFY_ERROR, 
                    errorData: response.data,        
                }    
            }       

            case types.CANCEL_REASONS_DELETE_SUCCESS:
            case types.CANCEL_REASONS_MASTER_DELETE_SUCCESS:
            const id = response.data.id;     
            if(response.status===200){
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),               
                    status: response.status,
                    activity:types.CANCEL_REASONS_DELETE_SUCCESS,   
                }       
    
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.CANCEL_REASONS_DELETE_ERROR,  
                    errorData: response.data, 
                }       
    
            }           
            
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name:''
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
    }
  };